export enum BlogContentType {
  TEXT = 'text',
  FILE = 'file',
}
